import { withPrefix } from "gatsby"
import React from "react"
import { Helmet } from "react-helmet"
import SITE_METADATA from "./SITE_META_DATA"

function MetadataSetHelmet(props) {
  return (
    <Helmet defer={false}>
      <title>{props.title ? props.title : SITE_METADATA.title}</title>
      <meta
        name="title"
        content={props.title ? props.title : SITE_METADATA.title}
      />
      <meta
        name="description"
        content={
          props.description ? props.description : SITE_METADATA.description
        }
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={props.url ? props.url : SITE_METADATA.url}
      />
      <meta
        property="og:title"
        content={props.title ? props.title : SITE_METADATA.title}
      />
      <meta
        property="og:description"
        content={
          props.description ? props.description : SITE_METADATA.description
        }
      />
      <meta
        property="og:image"
        content={props.image ? props.image : SITE_METADATA.image}
      />
      <meta property="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:url"
        content={props.url ? props.url : SITE_METADATA.url}
      />
      <meta
        property="twitter:title"
        content={props.title ? props.title : SITE_METADATA.title}
      />
      <meta
        property="twitter:description"
        content={
          props.description ? props.description : SITE_METADATA.description
        }
      />
      <meta
        property="twitter:image"
        content={props.image ? props.image : SITE_METADATA.image}
      />
      <script
        async
        src={withPrefix("scripts/customerly.js")}
        type="text/javascript"
      />
      <script
        src="https://cdn.onesignal.com/sdks/OneSignalSDK.js"
        async=""
      ></script>

      <script
        async
        src={withPrefix("scripts/onesignal.js")}
        type="text/javascript"
      />
    </Helmet>
  )
}

export default MetadataSetHelmet
